import * as React from 'react';
import { format } from 'date-fns';
import { Input, InputProps, Flex } from '@chakra-ui/react';
import {
  normalizeDateForApi,
  normalizeDateFromApi,
} from 'helpers/datetimeHelpers';

const DATE_FORMAT = 'yyyy-MM-dd';

interface InputDateProps {
  value: number | undefined;
  min?: Date | undefined;
  max?: Date | undefined;
  onChange: (value: any) => void;
  brColor?: string;
}
export const SimpleInputDate = ({
  value,
  min,
  max,
  onChange,
  isDisabled,
  brColor,
  ...props
}: InputDateProps & InputProps): JSX.Element => {
  const [date, setDate] = React.useState<number | undefined>(value);
  const [inputValue, setInputValue] = React.useState('');

  function handleInputDateChange(e: React.ChangeEvent<HTMLInputElement>): void {
    const inputValue = normalizeDateForApi(new Date(e?.target?.value));
    setDate(inputValue);
  }

  React.useEffect(() => {
    setDate(value);
  }, [value]);

  React.useEffect(() => {
    const newInputValue = date
      ? format(normalizeDateFromApi(date), DATE_FORMAT)
      : '';
    setInputValue(newInputValue);

    if (typeof onChange === 'function') onChange(date);
  }, [date]);

  return (
    <>
      <Flex gap={2}>
        <Input
          width='16ch'
          type='date'
          value={inputValue}
          min={min && format(min, DATE_FORMAT)}
          max={max && format(max, DATE_FORMAT)}
          onChange={handleInputDateChange}
          isDisabled={isDisabled}
          borderColor={brColor}
          {...props}
        />
      </Flex>
    </>
  );
};
